/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { ThreadModel } from "./ThreadModel";
export const ThreadResponse = core.serialization.object({
    data: ThreadModel,
});
